import { render, staticRenderFns } from "./TeacherServiceExamineBtn.vue?vue&type=template&id=46bfe608&scoped=true"
import script from "./TeacherServiceExamineBtn.vue?vue&type=script&lang=js"
export * from "./TeacherServiceExamineBtn.vue?vue&type=script&lang=js"
import style0 from "./TeacherServiceExamineBtn.vue?vue&type=style&index=0&id=46bfe608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bfe608",
  null
  
)

export default component.exports